{
  "name": "se26-web",
  "displayName": "SE26 Web",
  "branch": "development",
  "description": "SE26 marketing website.",
  "repos": {
    "se26-web": {
      "type": "client",
      "primary": true,
      "port": 0
    }
  },
  "packages": {
    "dmafjs-assetloader": "24.0.0-alpha.8",
    "dmafjs-control": "24.0.0-alpha.6",
    "dmafjs-core": "24.0.0-alpha.11",
    "dmafjs-navigation": "24.0.0-alpha.5",
    "dmafjs-visual": "24.0.0-alpha.10",
    "dmafjs-webaudio": "24.0.0-alpha.4",
    "dmafjs-web": "24.0.0-alpha.3",
    "dinahmic-build": "24.0.0-alpha.1",
    "dinahmic-test": "24.0.0-alpha.1"
  }
}
